import React from "react";

import DoneIcon from "@mui/icons-material/Done";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { IProfileIndustryData } from "store/types/user/social";

interface ITableExpertiseProps {
  data: IProfileIndustryData[];
}

export const IndustryExpertise: React.FC<ITableExpertiseProps> = ({ data }) => {
  if (!data.length) return null;

  const tableCellCommonStyle = {
    padding: 0,
    color: "#bac7ce",
    fontSize: "13px"
  };

  const rowBuilder = (data: IProfileIndustryData, index: number) => {
    const { title, operational, investment, learn_more } = data;
    return (
      <TableRow key={index}>
        <TableCell
          sx={{
            ...tableCellCommonStyle,
            color: "#0a3142",
            padding: "11px 0 11px 0 !important",
            textAlign: "left !important"
          }}
          align="center"
        >
          {title}
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          {operational && <DoneIcon sx={{ color: "#48a8d1" }} />}
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          {investment && <DoneIcon sx={{ color: "#48a8d1" }} />}
        </TableCell>
        <TableCell sx={{ ...tableCellCommonStyle }} align="center">
          {learn_more && <DoneIcon sx={{ color: "#48a8d1" }} />}
        </TableCell>
      </TableRow>
    );
  };

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "22px" }}>
        <Table sx={{ width: "100%" }} aria-label="simple table">
          <TableHead>
            <Typography color="#0a3142" fontSize="16px" fontWeight="500" mb="20px">
              Industry Expertise
            </Typography>
          </TableHead>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...tableCellCommonStyle, width: "61%" }} align="left"></TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "13%" }} align="center">
                Operational
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "13%" }} align="center">
                Investment
              </TableCell>
              <TableCell sx={{ ...tableCellCommonStyle, width: "13%" }} align="center">
                Interested
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{data.map((row, index) => rowBuilder(row, index))}</TableBody>
        </Table>
      </Box>
    </div>
  );
};
